export default __webpack_public_path__ + "static/media/btn_itemshop.5d5b1c1c.png";